import type { ApiTypes } from "@fluid-app/api-client";
import type { LeadCaptureWidgetProps } from "@fluid-app/react-widgets-types";
import { retrieveWidgetsChats } from "@fluid-app/api-client";
import {
  COOKIE_KEYS,
  STORAGE_KEYS,
  StorageManager,
} from "@fluid-app/storage-manager";

import { registerSingleWebComponent } from ".";
import widgetManifest from "../generated/widget-manifest.js";

function mapChatSettings(
  serverSettings: ApiTypes["widgets-chats-retrieve"]["response"]["chat"],
): LeadCaptureWidgetProps {
  return {
    hideWidget: !serverSettings?.trigger.show,
    size: serverSettings?.trigger.size,
    primaryColor: serverSettings?.styles.primaryColor,
    secondaryColor: serverSettings?.styles.secondaryColor,
    description: serverSettings?.content.subtitle,
    logoSrc: serverSettings?.content.mediaUrl,
    submitButtonText: serverSettings?.content.button_text,
    successMessage: serverSettings?.content.success_text,
    title: serverSettings?.content.title,
  } satisfies LeadCaptureWidgetProps;
}

async function createChat() {
  // Find the chat widget info from the manifest
  const chatWidgetInfo = widgetManifest.find(
    (w) => w.dirName === "lead-capture-widget",
  );

  if (chatWidgetInfo) {
    const storageManager = new StorageManager();
    const serverSettings = storageManager.getObject<
      ApiTypes["settings-retrieve"]["response"]
    >({ key: STORAGE_KEYS.SERVER_SETTINGS });
    const chatServerSettings = await retrieveWidgetsChats({
      request: {
        url: window.location.href,
        metadata: {
          fluid_session: serverSettings?.metadata?.fluid_session ?? "", // should always exist
          fluid_shop: serverSettings?.metadata?.fluid_shop ?? "", // should always exist
          attribution: serverSettings?.settings?.attribution,
          fluid_locale: serverSettings?.metadata?.fluid_locale ?? undefined,
          fluid_journey:
            storageManager.getItem({ key: COOKIE_KEYS.JOURNEY }) ?? undefined,
        },
      },
    });
    const mappedSettings = mapChatSettings(chatServerSettings.chat);
    console.log("Chat mapped settings:", mappedSettings);
    await registerSingleWebComponent(chatWidgetInfo, mappedSettings);
  } else {
    console.error("Chat widget info not found in widget-manifest.js");
  }
}

createChat().catch(console.error);
